import { render, staticRenderFns } from "./NeedTypeEdit.vue?vue&type=template&id=42ced493&"
import script from "./NeedTypeEdit.vue?vue&type=script&lang=js&"
export * from "./NeedTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports